if (!customElements.get('blog-predictive-search')) {
  customElements.define(
    'blog-predictive-search',
    class BlogPredictiveSearch extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.input = this.querySelector('input[name="q"]');
        this.results = this.querySelector('[data-blog-predictive-results]');

        if (!this.form || !this.input || !this.results) return;

        this.input.addEventListener('input', this.onInput.bind(this));
        this.input.addEventListener('keydown', this.onKeydown.bind(this));
        this.input.addEventListener('blur', this.onBlur.bind(this));
        this.form.addEventListener('reset', this.reset.bind(this));
      }

      onInput() {
        window.clearTimeout(this.debounceTimer);
        const term = this.input.value.trim();

        if (term.length < 2) {
          this.hideResults();
          return;
        }

        this.debounceTimer = window.setTimeout(async () => {
          this.setLoading(true);

          try {
            const articles = await this.fetchResults(term);
            if (term === this.input.value.trim()) this.renderResults(articles);
          } catch (error) {
            this.hideResults();
          } finally {
            this.setLoading(false);
          }
        }, 250);
      }

      onKeydown(event) {
        if (event.key === 'Escape') this.hideResults();
      }

      onBlur() {
        window.setTimeout(() => this.hideResults(), 150);
      }

      reset() {
        window.clearTimeout(this.debounceTimer);
        this.hideResults();
      }

      async fetchResults(term, fetchImpl = globalThis.fetch.bind(globalThis)) {
        const url = new URL(this.dataset.predictiveUrl, globalThis.location?.origin ?? 'https://example.test');
        url.searchParams.set('q', term);
        url.searchParams.set('resources[type]', 'article');
        url.searchParams.set('resources[limit]', '6');
        url.searchParams.set('resources[options][unavailable_products]', 'hide');

        const response = await fetchImpl(url.toString(), { credentials: 'same-origin' });
        if (!response.ok) throw new Error('Unable to load article suggestions.');

        const data = await response.json();
        return data.resources?.results?.articles ?? [];
      }


      renderResults(articles) {
        this.results.replaceChildren();

        if (!articles.length) {
          this.hideResults();
          return;
        }

        const list = document.createElement('ul');
        list.className = 'blog-predictive-search__list';

        articles.forEach((article) => {
          const item = document.createElement('li');
          const link = document.createElement('a');
          link.href = article.url;
          link.className = 'blog-predictive-search__result reversed-link';
          link.textContent = article.title;
          item.appendChild(link);
          list.appendChild(item);
        });

        this.results.appendChild(list);
        this.showResults();
      }

      setLoading(isLoading) {
        this.form?.toggleAttribute('aria-busy', isLoading);
      }

      showResults() {
        this.results.hidden = false;
        this.input.setAttribute('aria-expanded', 'true');
      }

      hideResults() {
        if (!this.results || !this.input) return;
        this.results.hidden = true;
        this.input.setAttribute('aria-expanded', 'false');
      }
    }
  );
}
